<template>
	<div class="hover-view">
		<div v-if="item" :class="['body', align]" :style="{
			gridTemplateColumns: _gridTemplateColumns
		}">
			<div class="type" :style="{
				backgroundColor: 'gray'
			}">
				<div class="label">Køretøj</div>
				<div class="tp"></div>
			</div>
			<div class="label">
				{{ item.name }}
				<div class="num">
					{{ item.reg_no | optional }}
				</div>
			</div>
			<div class="info">
				<table cellspacing="5" cellpadding="0">
					<tr>
						<td class="label">Producent</td>
						<td class="value">{{ item.make | optional }}</td>
					</tr>
					<tr>
						<td class="label">Model</td>
						<td class="value">{{ item.model | optional }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Længde</td>
						<td class="value">{{ item.length | optional }}</td>
					</tr>
					<tr>
						<td class="label">Bredde</td>
						<td class="value">{{ item.width | optional }}</td>
					</tr>
					<tr>
						<td class="label">Højde</td>
						<td class="value">{{ item.height | optional }}</td>
					</tr>
				</table>
			</div>
			<div v-if="_roles.length > 0" class="info roles">
				<div v-for="(role, i) in _roles" :key="i" class="block">
					<div class="title">{{ role.label }}</div>
					<div class="desc">
						<table cellspacing="5" cellpadding="0">
							<tr v-for="(prop, j) in role.props" :key="j">
								<td class="label">{{ prop.label }}</td>
								<td class="value">{{ prop.value | optional }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<div v-if="_my_events.length > 0" class="info events">
				<div class="title">Kørsel</div>
				<table cellspacing="5" cellpadding="0">
					<tr v-for="(event, i) in _my_events" :key="i">
						<td class="value label" style="font-family: 'Roboto Mono'; font-size: 11px;">{{ event.time }}</td>
						<td class="label" style="font-size: 11px;">{{ eventTypes[event.event] }}</td>
						<td class="right" style="white-space: nowrap; text-overflow: ellipsis; font-size: 11px;">{{ event.address }}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				eventTypes: {
					'start':	'Kører',
					'stop': 	'Stop',
					'enter': 	'Ankommer',
					'leave': 	'Forlader'
				}
			};
		},
		props: {
			item: {
				type: Object,
				default: null
			},
			align: {
				type: String,
				default: 'left'
			},
			roles: {
				type: Array,
				default() {
					return [];
				}
			},
			events: {
				type: Array,
				default() {
					return null;
				}
			}
		},
		methods: {

		},
		computed: {
			_roles() {
				const self = this;

				return this.roles.reduce((acc, item) => {
					if (self.item.roles.hasOwnProperty(item.name) && self.item.roles[item.name].enabled) acc.push({
						label: item.label,
						props: item.props.map((prop) => {
							var v = self.item.roles[item.name].props[prop.name];

							if (typeof v == 'boolean') {
								v = v ? 'Ja' : 'Nej';
							} else if (typeof v == 'undefined' || v.toString().length == 0) {
								v = null;
							}

							return {
								label: prop.label,
								value: v
							};
						})
					});

					return acc;
				}, []);
			},
			_my_events() {
				const self = this;
				return this.events === null ? [] : this.events.filter((item) => { return self.item.id == item.vehicle_id; });
			},
			_gridTemplateColumns() {
				var r = ['30px', 'auto'];

				if (this._roles.length > 0) {
					r.push('auto');
				}

				if (this._events.length > 0) {
					r.push('auto');
				}

				return r.join(' ');
			}
		},
		watch: {

		}
	}
</script>

<style lang="scss" scoped>
	.hover-view {
		pointer-events: none;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		& > .body {
			&.left {
				left: 20px;
			}

			&.right {
				right: 20px;
			}

			background-color: white;
			border-radius: 5px;
			overflow: hidden;
			position: absolute;
			bottom: 20px;
			display: grid;
			grid-template-rows: auto 1fr 20px;
			min-width: 500px;

			-webkit-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			-moz-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);

			& > .type {
				color: white;
				font-weight: bold;
				grid-column: 1;
				grid-row: 1 / 4;
				position: relative;

				& > .label {
					position: absolute;
					bottom: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
					white-space: nowrap;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-left: 10px;
				}

				& > .tp {
					position: absolute;
					top: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-right: 10px;
				}
			}

			& > .label {
				grid-column: 2 / end;
				grid-row: 1;
				padding: 20px;
				font-size: 16px;
				font-weight: bold;

				& > .num {
					float: right;
					font-size: 16px;
					font-weight: bold;
				}
			}

			& > .info {
				padding: 0 30px 0 20px;
				max-width: 1000px;

				& table {
					border-spacing: 0;
    				border-collapse: separate;
				}
				
				& > table td, & > * > table td, & > * > * > table td   {
					vertical-align: top;
					font-size: 14px;
					line-height: 20px;

					::v-deep .tag {
						display: inline-block;
						background-color: #f7223f;
						font-size: 12px;
						color: white;
						padding: 3px 5px 3px 5px;
						border-radius: 3px;
						margin-top: 4px;
						margin-bottom: 6px;
						padding-left: 0;
					}

					&.label {
						padding-right: 20px;
					}

					&.value {
						font-weight: bold;
					}

					&.sep {
						height: 10px;
					}

					&.right {
						text-align: right;
					}
				}

				&.events {
					padding-right: 20px;

					& table {
						margin-top: 10px;
						width: 100%;
					}

					& table td {
						font-size: 12px;
						border-top: 1px solid #e9e9e9;
					}

					& table tr:first-child td {
						border-top: none;
					}
				}
			}

			& > .dyn, & > .info {
				border-left: 1px solid #e9e9e9;
				padding: 0 50px 0 20px;

				&.instr {
					max-width: 550px;
				}

				& > .title {
					font-weight: bold;
				}

				& > .block {
					padding-bottom: 10px;

					& > .title {
						font-weight: bold;
						margin-bottom: 5px;
					}

					& > .desc {
						padding-top: 5px;
						font-size: 14px;

						& > .status {
							display: inline-block;
							width: 6px;
							height: 6px;
							border-radius: 50%;
							margin-right: 8px;
							position: relative;
							top: -2px;
						}
					}
				}
			}
		}
	}
</style>